/* @flow */
import React from 'react';
import { Field } from 'redux-form/immutable';
import { fromJS } from 'immutable';
import { Select, Toggle } from 'trustar/components';

export const RenderToggle = ({ input: { checked, onChange}, className, identifier, cyid }: Object) => (
  <Toggle
    cyid={cyid || identifier}
    checked={checked}
    className={className}
    onChange={() => onChange(!checked)} />
);

const normalizeToJS = x => {
  if (x && typeof x.toJS === 'function') {
    return x.toJS();
  } else {
    return x;
  }
};

export const RenderSelect = (props: Object) => {
  const {
    input: { value, onChange },
    meta,
    multi,
    options,
    placeholder,
    className,
    identifier,
    cyid,
    SelectComponent = Select, // SelectComponent can be customized, but should match react-select API
    ...childProps
  } = props;
  return (
    <div data-cy={cyid || 'select-field'}>
      <SelectComponent
        {...childProps}
        multi={!!multi}
        options={options}
        className={className}
        placeholder={placeholder}
        value={normalizeToJS(value)}
        onChange={e => onChange(fromJS(e))}
      />
      {meta && meta.error && <span>{meta.error}</span>}
    </div>
  );
};

export const RenderFieldToggle = ({
  name,
  checked,
  disabled,
  className,
  label,
  labelClassName,
  id,
}: Object) => {
  return (
    <Field
      type='checkbox'
      name={name}
      checked={checked}
      disabled={disabled}
      label={label}
      id={id}
      labelClassName={labelClassName}
      component={({ input, ...childProps }: Object) => {
        const { checked, onChange } = input;
        return (
          <Toggle
            {...childProps}
            checked={checked}
            className={className}
            onChange={() => onChange(!checked)} />
        );
      }} />
  );
};

// TODO: Refactor classNames...
export const RenderSelectWithIcon = (props: Object) => {
  const {
    input: { value, onChange },
    icon,
    multi,
    options,
    placeholder,
    innerClassName,
    outerClassName,
    cyid,
    identifier,
    SelectComponent = Select, // SelectComponent can be customized, but should match react-select API
    ...childProps
  } = props;

  return (
    <div data-cy={cyid || 'select-field-with-icon'} className={outerClassName}>
      {icon && <i className={`fa ${icon}`} />}
      <SelectComponent
        {...childProps}
        multi={!!multi}
        options={options}
        className={innerClassName}
        placeholder={placeholder}
        value={normalizeToJS(value)}
        onChange={e => onChange(fromJS(e))}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./web_modules/trustar/components/FormComponents.js